import validate from "/usr/src/app/content/n3-promos-159acf66-cc0e-447f-8474-2f9b54ffc7ae/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-159acf66-cc0e-447f-8474-2f9b54ffc7ae/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}